<template>
  <div>
    <ConfirmationDialog ref="confirm" :function-yes="bindingFunction"></ConfirmationDialog>
    <v-btn :disabled="(!estadoPermissions.canSubmit) || loading" color="primary"  @click="presentar">Finalizar</v-btn>
  </div>
</template>

<script>
import ConfirmationDialog from '../../../common/ui/ConfirmationDialog'

export default {
  props: {
    estadoPermissions: Object
  },
  components: {
    ConfirmationDialog
  },

  data () {
    return {
      loading: false,
      bindingFunction: null
    }
  },

  methods: {
    presentar () {
      this.bindingFunction = () => {
        this.loading = true
        this.axios
          .put(`/presentaciones/finalizar-cargalpf/${this.$route.params.id}`)
          .then(() => {
            this.loading = false
            this.$router.push({ name: 'presentacionesCargaLpf' })
          })
          .catch(error => {
            this.loading = false
            this.$store.commit('setErrorMsg', error)
          })
      }
      this.$refs.confirm.openDialog()
    }
  }
}
</script>
